//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import { IngestJob } from '../../utils/MCPDataService';

// Renders an IngestJob's phase label and progress bar color/width for
// MCPTab's inline per-row Status column.
export const PHASE_LABELS: Record<string, string> = {
  queued: 'Waiting in queue',
  fetching_tools: 'Fetching tools…',
  classifying: 'Classifying tools…',
  embedding: 'Embedding tools…',
  indexing: 'Indexing…',
  completed: 'Completed',
  failed: 'Failed',
};

export function phaseLabel(job: IngestJob): string {
  return PHASE_LABELS[job.phase] || job.phase;
}

export function progressPercent(job: IngestJob): number {
  if (!job.progress || !job.progress.total) return 0;
  return Math.min(
    100,
    Math.round((job.progress.current / job.progress.total) * 100),
  );
}

export function barColorClass(job: IngestJob): string {
  if (job.status === 'failed') return 'bg-destructive';
  if (job.status === 'completed') return 'bg-status-successGreen';
  return 'bg-brand-interactive';
}

export function barWidth(job: IngestJob): string {
  if (job.phase === 'embedding' && job.progress)
    return `${progressPercent(job)}%`;
  if (job.status === 'completed' || job.status === 'failed') return '100%';
  return '40%';
}
